import React from 'react'
import './style.scss'
import { useTheme } from '../../../context/Theme'

export default function ThemeSelector() {
    const { theme, setTheme } = useTheme()

    return (
        <div className="theme-selector-container">
            <h5 className="mb-1">Tema</h5>
            <p className="theme-description mb-3">
                Personalize a aparência do sistema. A preferência é salva automaticamente.
            </p>
            <div className="theme-selector">
                <div
                    className={`theme-card light ${theme === 'light' ? 'selected' : ''}`}
                    onClick={() => setTheme('light')}
                >
                    <div className="preview"></div>
                    <span>Claro</span>
                </div>
                <div
                    className={`theme-card dark ${theme === 'dark' ? 'selected' : ''}`}
                    onClick={() => setTheme('dark')}
                >
                    <div className="preview"></div>
                    <span>Escuro</span>
                </div>
            </div>
        </div>
    )
}
